import type { ReactNode } from 'react'
import { useReveal } from './use-reveal'
import { cn } from '@/lib/utils'

interface RevealProps {
  readonly children: ReactNode
  readonly className?: string
  readonly stagger?: boolean
  readonly as?: 'div' | 'section'
}

export function Reveal({ children, className, stagger, as: As = 'div' }: RevealProps) {
  const { ref, visible } = useReveal<HTMLDivElement>()

  return (
    <As
      ref={ref as never}
      className={cn(
        stagger ? 'landing-stagger' : 'landing-reveal',
        visible && 'is-visible',
        className,
      )}
    >
      {children}
    </As>
  )
}
